import React from 'react'
import { ResponsiveContainer,AreaChart,XAxis,Tooltip,Area,CartesianGrid  } from 'recharts'
import carStaticsData from'../assets/dummy-data/carStatics'
const CarStatsChart = () => {
  return (
    <ResponsiveContainer>
    <AreaChart  data={carStaticsData}
  margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
  <defs>
    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
      <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
      <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
    </linearGradient>
    <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
      <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
      <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
    </linearGradient>
  </defs>
  <XAxis dataKey="name" stroke="#000" />
  
  <CartesianGrid strokeDasharray="0" stroke="b7ffe913" />
  <Tooltip />
  
  <Area type="monotone" dataKey="prevWeek" stroke="#82ca9d" fillOpacity={1} fill="url(#colorPv)" />
</AreaChart>  
    </ResponsiveContainer>
  )
}

export default CarStatsChart
